/**
 * QueueContext - Thin composition wrapper that provides both BriefQueue and EpisodeQueue.
 * 
 * This maintains backward compatibility for AudioPlayerContext which needs both queues.
 * Individual consumers should prefer importing from BriefQueueContext or EpisodeQueueContext directly.
 */
import React, { ReactNode } from 'react';
import { BriefQueueProvider } from './BriefQueueContext';
import { EpisodeQueueProvider } from './EpisodeQueueContext';

// Re-export types for backward compatibility
export type { QueueItem } from './BriefQueueContext';
export type { EpisodeQueueItem } from './EpisodeQueueContext';
export { useBriefQueue, useBriefQueueOptional } from './BriefQueueContext';
export { useEpisodeQueue, useEpisodeQueueOptional } from './EpisodeQueueContext';

/**
 * Composes BriefQueueProvider + EpisodeQueueProvider into a single provider.
 * Keeps the App.tsx provider tree clean.
 */
export function QueueProvider({ children }: { children: ReactNode }) {
  return (
    <BriefQueueProvider>
      <EpisodeQueueProvider>
        {children}
      </EpisodeQueueProvider>
    </BriefQueueProvider>
  );
}
